module.exports = __webpack_public_path__ + "static/media/furreEndly2.1d96d7b3.jpg";